import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { salesManagement, setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import {
  DiscountRulesQuery,
  SellingPriceRulesQuery,
} from "../../../data/Axios/queries";
import DiscountTypeForm from "./Form";
import DiscountRuleForm from "./Form";

const base_url = setupManagementUrl.uri;
//const base_url = "https://localhost:7022/graphql/"
const actions = {
  entity: "Selling Price Rules",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  showStatus: true,
};
function SellingPriceRules() {
  const ignore = [
    "created_by",
    "companyid",
    "updated_by",
    "updated_at",
    "created_at",
  ];
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Selling Price Rules"
          subtitle="Manage Selling Price Rules"
          ignoreFields={ignore}
          FormComponent={DiscountRuleForm}
          query={SellingPriceRulesQuery}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default SellingPriceRules;
